import apiApp from "./index";

const token = localStorage.getItem("UserjwtToken");
const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

const switched = localStorage.getItem("switched");
const switchedSubtenant = JSON.parse(localStorage.getItem("switchedSubtenant"));
// helper: return query param if subTenantId exists
const getSubTenantIdParam = () => {
    if (decodedToken?.isMultitenancy && decodedToken?.subTenantId !== undefined) {
        const subTenantId = decodedToken?.subTenantId;
        return subTenantId ? `&subTenantId=${subTenantId}` : "";
    } else if (switched && switchedSubtenant) {
        return `&subTenantId=${switchedSubtenant?.id}`;
    }
    return "";
};

// ✅ helper: inject subTenantId into request body if exists
const injectSubTenantId = (data) => {
    if (decodedToken?.isMultitenancy && decodedToken?.subTenantId) {
        const jsonData = JSON.parse(data);
        jsonData.subTenantDTO = { id: decodedToken.subTenantId };
        return JSON.stringify(jsonData);
    }
    return data;
};

// ✅ helper: construct headers dynamically
const constructHeaders = () => {
    const headers = {
        Authorization: `Bearer ${token}`,
        "x-Authorization": `${decodedToken?.tenantApiKey}`,
    };

    if (
        decodedToken?.roles?.includes("TENANT_ADMIN") ||
        decodedToken?.subTenantId === undefined
    ) {
        headers["tenant-login"] = true;
    }

    return headers;
};

const StorageSuggestionApi = {
    // ✅ Create Storage
    CreateStorage: (data) => {
        data = injectSubTenantId(data);
        const headers = constructHeaders();

        return new Promise((resolve, reject) => {
            apiApp
                .post(`/storage-suggestions`, data, { headers })
                .then((response) => resolve(response.data))
                .catch((error) => reject(error.response?.data));
        });
    },

    // ✅ Update Storage
    PutStorage: (storageID, data) => {
        data = injectSubTenantId(data);
        const headers = constructHeaders();

        return new Promise((resolve, reject) => {
            apiApp
                .put(`/storage-suggestions/${storageID}`, data, { headers })
                .then((response) => resolve(response.data))
                .catch((error) => reject(error.response?.data));
        });
    },

    // ✅ Get Single Storage
    Singlestorage: (storageID) => {
        const headers = constructHeaders();

        return new Promise((resolve, reject) => {
            apiApp
                .get(
                    `/storage-suggestions/${storageID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
                    { headers }
                )
                .then((response) => resolve(response.data))
                .catch((error) => reject(error.response?.data));
        });
    },

    // ✅ List Storage
    ListStorage: (page, limit) => {
        const headers = constructHeaders();

        return new Promise((resolve, reject) => {
            apiApp
                .get(
                    `/storage-suggestions?page=${page}&size=${limit}&sort=desc&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
                    { headers }
                )
                .then((response) => resolve(response.data))
                .catch((error) => reject(error.response?.data));
        });
    },

    // ✅ Delete Storage
    DeleteStorage: (storageID) => {
        const headers = constructHeaders();

        return new Promise((resolve, reject) => {
            apiApp
                .delete(
                    `/storage-suggestions/${storageID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
                    { headers }
                )
                .then((response) => resolve(response.data))
                .catch((error) => reject(error.response?.data));
        });
    },
};

export default StorageSuggestionApi;
